import { ArrowConfig } from "konva/lib/shapes/Arrow";
import { PathConfig } from "konva/lib/shapes/Path";
import { ARROW_COLOR_Base, ARRROW_LINK_TASK_COLOR, baseAccent, basePrimary } from "../styles/graph-colors";

// Base Arrow
export const MIN_ARROW_LENGTH = 50;
export const ARROW_STROKE_WIDTH_Base = 1;
export const ARROW_DAGRE_POINTER_WIDTH = 10;
export const ARROW_DAGRE_POINTER_HEIGHT = 10;

export const ARROW_POINTER_RADIUS = 5;
export const ARROW_TENSION = 0.15;
export const ARROW_DAGRE_DASH = 10;
export const CONTRACT_POINTER_WIDTH = 15;
export const CONTRACT_POINTER_HEIGHT = 12;
export const ARROW_POINTER_MARGIN = 1;
export const ARROW_START_MARGIN = 1;

export const ARROW_MODEL:ArrowConfig = {
    curvePower: 1,
    tension: 0.1,
   // bezier: true,
    fill: ARROW_COLOR_Base,
    strokeWidth: ARROW_STROKE_WIDTH_Base,
    stroke: ARROW_COLOR_Base,
    pointerWidth:10,
    pointerLength:12,
    points: [],
}
//Link between Contract graph and Task graph 
export const ARROW_LINK_TASK_MODEL:ArrowConfig = {
    id: 'LinkToActiveStep',
    //tension: 0.5,
    //dash: [10],
    stroke: baseAccent,
    strokeWidth: ARROW_STROKE_WIDTH_Base,
    fill: baseAccent,
    points: [],
    bezier:false
}
export const Path_LINK_TASK_MODEL:PathConfig = {
    id: 'LinkToActiveStepPath',
    //tension: 0.5,
    //dash: [10],
    stroke: ARRROW_LINK_TASK_COLOR,
    //fill: ARRROW_LINK_TASK_COLOR,
}
//Link between Contract graph and Subcontract graph 
export const ARROW_LINK_SUBCONTRACT_MODEL:ArrowConfig = {
    id: 'connect_edge',
   // tension: 0.1,
   //bezier:true, 
   //dash: [10],
    stroke: basePrimary,
    strokeWidth: 1,
    fill: basePrimary,
    points: []
}